module.exports = __webpack_public_path__ + "static/media/video-poster.5f191d8b.gif";